import axios from 'axios'
import api from '@/api'

const patientsDiagnosis = {
  state: {
    data: []
  },
  getters: {
    getPatientsInformation: state => state.data,
    getPatientsInformationData: state => state.data.data_fields,
    getPatientsSpecializationData: state => state.data.specializations,
  },
  mutations: {
    PATIENT_INFORMATION_GET (state, payload) {
      state.data = payload
    },
  },
  actions: {
    patientsInformationGet (context) {
      axios({
        method: 'POST',
        url: `${api}patients/diagnosis-information/template`,
      }).then(response => {
        context.commit('PATIENT_INFORMATION_GET', response.data);
      }).catch((error) => {
        console.log(error);
      })
    },
    patientsInformationEditGet (context, value) {
      axios({
        method: 'POST',
        url: `${api}/patients/result-diagnosis/item/` + value,
      }).then(response => {
        context.commit('PATIENT_INFORMATION_GET', response.data);
      }).catch((error) => {
        console.log(error);
      })
    }
  }
};
export default patientsDiagnosis
